module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=NA - Namibia.2d910bfd.svg";